import type { Participant } from "@twilio/conversations";

import type { ChatParticipant } from "./types";

export const normalizeParticipant = (
  participant: Participant,
): ChatParticipant => ({
  sid: participant.sid,
  attributes: participant.attributes,
  identity: participant.identity,
  type: participant.type,
  lastReadMessageIndex: participant.lastReadMessageIndex,
});
